import "@abaco/abc-icons";
import ActivitiesModule from "@abaco/activities-module/src/modules/activities-module";
import AgreementsModule from "@abaco/agreements-module/src/modules/agreements/index";
import AgromatriciWidgetsModule from "@abaco/widgets-container-module/src/modules/agromatrici-widgets/index";
import AlarmsModule from "@abaco/alarms-module/src/modules/alarms-module";
import AniaDashboardModule from "@abaco/ania-dashboard-module/src/modules/ania-dashboard-module";
import AssetsModule from "@abaco/assets-module/src/modules/assets-module";
import BaseEmbeddedSectionsModule from "@abaco/base-embedded-sections-module/src/modules/base-embedded-sections";
import BuyerContractModule from "@abaco/buyer-contract-module/src/modules/buyer-contract-module";
import ChillingWidgetModule from "@abaco/chilling-widget-module/src/modules/chilling-widget-module/index";
import ColdirettiEmbeddedSectionsModule from "@abaco/coldiretti-embedded-sections-module/src/modules/coldiretti-embedded-sections";
import ColdirettiWidgetsModule from "@abaco/widgets-container-module/src/modules/coldiretti_widgets/index";
import GenericWidgetsModule from "@abaco/widgets-container-module/src/modules/generic-widgets/index";
import CostRevenuesModule from "@abaco/costs-revenues-module/src/modules/costs-revenues-module/index";
import CropPlanModule from "@abaco/crop-plan-module/src/modules/crop-plan-module";
import BigDataGrapeWidgetModule from "@abaco/widgets-container-module/src/modules/big-data-grapes-widget/index";
import DamageClaimModule from "@abaco/damage-claim-module/src/modules/damage-claim-module/index";
import DashboardModule from "@abaco/dashboard-module/src/modules/dashboard";
import DemetraAnalysisManagementModule from "@abaco/demetra-analyses-management/src/modules/demetra-analyses-management-module/index";
import DemoColdirettiPopUpModule from "@abaco/user-module/src/modules/demoColdirettiPopUp/index";
import OldWidgetsModule from "@abaco/widgets-container-module/src/modules/old-widgets";
import UnifiWidgetsModule from "@abaco/widgets-container-module/src/modules/unifi_widgets/index";
import DatahubModule from "@abaco/datahub-module/src/modules/datahub-module/index";
import DossierModule from "@abaco/dossier-module/src/modules/dossier/index";
import EarthwormWidgetModule from "@abaco/earthworm-widget-module/src/modules/earthworm-widget-module/index";
import EnvironmentalWidget from "@abaco/widgets-container-module/src/modules/ambiental_widgets/index";
import ETLModule from "@abaco/etl-module/src/modules/etl/index";
import ExtractionModule from "@abaco/extraction-module/src/modules/extraction-module/index";
import FarmMapModule from "@abaco/widgets-container-module/src/modules/farm-map-module";
import FarmRegistryModule from "@abaco/farm-registry/src/modules/farm-registry";
import FertilizerPlanModule from "@abaco/fertilizer-plan-module/src/modules/fertilizer-plan-module/index";
import FerrariWidgetsModule from "@abaco/widgets-container-module/src/modules/ferrari-widgets/index";
import FerreroWidgetsModule from "@abaco/ferrero-widget-module/src/modules/ferrero-widget-module/index";
import FerreroDashboardModule from "@abaco/ferrero-dashboard-module/src/modules/counts-dashboard-module/index";
import FerreroFixedDashboardModule from "@abaco/ferrero-fixed-dashboard-module/src/modules/ferrero-fixed-dashboard-module/index";
import FibeoModule from "@abaco/fibeo-module/src/modules/fibeo-dashboard-module/index";
import GabModule from "@abaco/gab-module/src/modules/gab-module/index";
import Geotagging from "@abaco/geo-tagging/src/abaco-module";
import GrapesDashboardModule from "@abaco/grapes-dashboard-module/src/modules/grapes-dashboard-module/index";
import HelperModule from "@abaco/helper-module/src/modules/helper-module/index";
import IotModule from "@abaco/iot-module/src/modules/iot";
import IrradiationWidgetModule from "@abaco/irradiation-widget-module/src/modules/irradiation-widget-module/index";
import KnowledgeModule from "@abaco/knowledge-module/src/modules/knowledge-module/index";
import LayerManagementModule from "@abaco/layer-management-module/src/modules/layer-management-module/index";
import LivestocksCountingModule from "@abaco/nd-module/src/modules/livestocks-counting/index";
import MapModule from "@abaco/map-web-module/src/modules/map-web-module";
import MaltaEmbeddedModule from "@abaco/malta-embedded-module/src/modules/malta-embedded-module/index";
import MelaviWidgetsModule from "@abaco/widgets-container-module/src/modules/melavi-widgets/index";
import MeteoWidgetModule from "@abaco/widgets-container-module/src/modules/meteo-widgets/index";
import MessagesModule from "@abaco/messages-module/src/modules/messages/index";
import MenuModule from "@abaco/menu-module/src/modules/menu";
import MosiModule from "@abaco/widgets-container-module/src/modules/mosi-widgets";
import MowingWidgetModule from "@abaco/mowing-widget-module/src/modules/mowing-widget-module/index";
import NewAgreementsModule from "@abaco/agreements-module/src/modules/new-agreements/index";
import NitratesDeclarationModule from "@abaco/nd-module/src/modules/nd/index";
import ParcelTenureModule from "@abaco/parcel-tenure-module/src/modules/parcel-tenure-module/index";
import PcertModule from "@abaco/pcert-module/src/modules/pcert-module/index";
import PedologyModule from "@abaco/pedology-module/src/modules/pedology-module/index";
import PesslDiseasesWidgetModule from "@abaco/pessl-diseases-widget-module/src/modules/pessl-diseases-widget-module/index";
import PizzoliWidgetModule from "@abaco/widgets-container-module/src/modules/pizzoli-widgets/index";
import PmiInspectionModule from "@abaco/inspection-module/src/modules/inspection-module/index";
import PoiModule from "@abaco/poi-module/src/modules/poi-modules/index";
import PortalGlobalStateModule from "@abaco/portal-global-state/src/modules/global-state";
import PpmModule from "@abaco/ppm-widget-module/src/modules/ppm-widget-module";
import PrecisionFarmingModule from "@abaco/precision-farming-module/src/modules/precision-farming-module/index";
import PrescriptionModule from "@abaco/prescription-module/src/modules/prescriptions/index";
import PrincesWidgetsModule from "@abaco/widgets-container-module/src/modules/princes-widgets/index";
import ProcessesModule from "@abaco/processes-module/src/modules/processes";
import ProtocolModule from "@abaco/protocol-module/src/modules/protocol/index";
import ProviderServiceDionisoModule from "@abaco/provider-service-dioniso-module/src/modules/provider-service-dioniso/index";
import PuaModule from "@abaco/pua-module/src/modules/pua/index";
import SatelliteIndexesModule from "@abaco/widgets-container-module/src/modules/satellites-widgets";
import SmartAgriWidgetModule from "@abaco/smart-agri-widget-module/src/modules/smart-agri-widget-module/index";
import SouthernWatersWidgetModule from "@abaco/southern-waters-widget-module/src/modules/southern-waters-widget-module/index";
import SoilHealthModule from "@abaco/soil-health-widget-module/src/modules/soil-health-widget-module/index";
import SsoAdministrationModule from "@abaco/sso-administration-module/src/modules/sso-administration-module/index";
import SsoWebModule from "@abaco/sso-web-module/src/abaco-module";
import SupplyChainViewModule from "@abaco/supply-chain-view-module/src/modules/supply-chain-view-module/index";
import ThermoWidgetModule from "@abaco/thermo-widget-module/src/modules/thermo-widget-module/index";
import TilesFramework from "@abaco/tiles-framework/src/components";
import TimeSheetModule from "@abaco/timesheet-module/src/modules/timesheet-module/index";
import TrapsModule from "@abaco/traps-module/src/modules/traps-module/index";
import TreatmentRegisterModule from "@abaco/treatment-register-module/src/modules/treatment-register-module/index";
import UnaprolEmbeddedSectionsModule from "@abaco/unaprol-embedded-sections-module/src/modules/unaprol-embedded-sections";
import UserModule from "@abaco/user-module/src/modules/user-module";
import R2UDashboardModule from "@abaco/r2u-dashboard-module/src/modules/r2u-dashboard-module";
import { Application } from "@abaco/web-common/src/app";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import WebComponents, { setI18N } from "@abaco/web-components/src/components";
import Vue from "vue";
import App from "./App.vue";
import Home from "./Home.vue";
import FerreroChartsModule from "./modules/ferreroCharts/index";
import NavigationGisModule from "./modules/navigationGis";
import OuterLoginModule from "./modules/outerLogin";
import MaltaS4fScpBridge from "./modules/maltaScpBridge";
import { EnvConfig, I18nVariant } from "@abaco/web-common/src/app/Application";
import { startMatomo } from "./utils/matomo";

// import IrradiationWidgetModule from "@abaco/irradiationWidgetModule/src/modules";

Vue.use(TilesFramework);
Vue.use(WebComponents);

// !! if doesn't work at compile time, require wins. So we are moving scss file in ci before build
if (process.env.VUE_APP_THEME) {
    require("./assets/styles/themes/" + process.env.VUE_APP_THEME + ".scss");
}

Vue.config.productionTip = false;

const MODE = process.env.VUE_APP_MODE || "portal";

const isMalta = MODE === "malta" || MODE === "malta-pmp";
const isFerreroOutGrower = MODE === "ferrero-outgrower";
const isFerreroCounting = MODE === "ferrero-counting";
const isFerrero = isFerreroCounting || isFerreroOutGrower;
const isPortal = MODE === "portal";
const isColdiretti = MODE.includes("coldiretti");
const isAbruzzo = MODE === "abruzzo";
const isSian = MODE === "sian";
const isR2u = MODE === "r2u";
const isA4grapes = MODE === "a4grapes";
const isNiab = MODE === "niab";
const isOntDemetra = MODE === "coldiretti-ont-demetra";
const isRemtec = MODE === "remtec";
const isColdirettiDemo = MODE === "coldiretti-demo";

let i18nVariant: I18nVariant | undefined = undefined;
if (isA4grapes || isRemtec) {
    i18nVariant = {
        modules: [
            ActivitiesModule.MODULE_ID,
            AssetsModule.MODULE_ID,
            CostRevenuesModule.MODULE_ID,
            FarmRegistryModule.MODULE_ID,
            IotModule.MODULE_ID,
            MenuModule.MODULE_ID,
            OldWidgetsModule.MODULE_ID,
            PortalGlobalStateModule.MODULE_ID,
            PrecisionFarmingModule.MODULE_ID,
            ProtocolModule.MODULE_ID,
            SupplyChainViewModule.MODULE_ID,
            TreatmentRegisterModule.MODULE_ID,
            CropPlanModule.MODULE_ID,
        ],
        variant: "a4grapes",
    };
}
if (isFerrero) {
    i18nVariant = {
        modules: [AgreementsModule.MODULE_ID, NewAgreementsModule.MODULE_ID],
        variant: "ferrero",
    };
}

if (isColdirettiDemo) {
    i18nVariant = {
        modules: [CropPlanModule.MODULE_ID],
        variant: "coldiretti_demo",
    };
}

const http = new HTTPClient({ useApiSSO: isColdiretti });
if (isA4grapes || isRemtec) {
    http.addRequestConfigProvider(async (config) => {
        config.headers = { ...config.headers, Verticalization: "VINE" };
    });
}
if (isFerreroOutGrower) {
    http.addRequestConfigProvider(async (config) => {
        config.headers = { ...config.headers, Verticalization: "OUTGROWER" };
    });
}
if (isFerreroCounting) {
    http.addRequestConfigProvider(async (config) => {
        config.headers = { ...config.headers, Verticalization: "COUNTING" };
    });
}
if (isOntDemetra) {
    http.addRequestConfigProvider(async (config) => {
        config.headers = { ...config.headers, Verticalization: "TABACCO" };
    });
}

const abacoApp = new Application({
    http: http,
    rootComponent: Home,
    enableGtag: true,
    i18nVariant: i18nVariant,
});

const menu = new MenuModule();
const oldWidgets = new OldWidgetsModule(MODE);

const loginPage = () => {
    if (isColdirettiDemo) {
        return "coldiretti-demo-login-page";
    }
    if (
        MODE === "coldiretti-smartagri" ||
        MODE === "coldiretti-unaprol" ||
        MODE === "coldiretti-ibf"
    ) {
        return "coldiretti-partner-login-page";
    }
    if (MODE === "coldiretti") {
        return "coldiretti-partner-operator-login-page";
    }
    if (isAbruzzo) {
        return "spid-login";
    }
    if (isRemtec) {
        return "proxy-login|a4grapes";
    }
    return "login-page";
};

abacoApp.add(
    new SsoWebModule(
        {
            loginContext: process.env.VUE_APP_LOGIN_CONTEXT || "PORTALE",
            environment: isFerrero ? "PORTAL_FERRERO" : MODE,
            useSSO1: false,
            loginPage: loginPage(),
            hideLoginBaseTab: isRemtec,
        },
        (user) => {
            setI18N({ locale: user.locale, dateFormat: user.dateFormat });
            abacoApp.setLanguage(user.locale);
            menu.loadMenu();
            if (!isFerrero) {
                oldWidgets.resetCache();
            }
        }
    )
);

abacoApp.add(new AgromatriciWidgetsModule());
abacoApp.add(new ActivitiesModule());
abacoApp.add(new AgreementsModule());
abacoApp.add(new AlarmsModule());
abacoApp.add(new AniaDashboardModule());
abacoApp.add(new AssetsModule());
abacoApp.add(new BaseEmbeddedSectionsModule());
abacoApp.add(new CostRevenuesModule());
abacoApp.add(new CropPlanModule({ environment: MODE }));
abacoApp.add(new ChillingWidgetModule());
abacoApp.add(
    new DashboardModule({
        software: MODE,
        hasEstraGlobals: !isFerrero,
        hasSecondaryNavBarItem: process.env.VUE_APP_HORIZONTAL_MENU
            ? true
            : false,
        hasCompactSidebarMenu: process.env.VUE_APP_COMPACT_SIDEBAR_MENU
            ? true
            : false,
    })
);
abacoApp.add(new DatahubModule());
abacoApp.add(new DossierModule());
abacoApp.add(new ETLModule());
abacoApp.add(new EnvironmentalWidget());
abacoApp.add(new FarmMapModule({ hasExtraGlobals: false, environment: MODE }));
abacoApp.add(
    new FarmRegistryModule({ isReadOnly: isMalta, environment: MODE })
);
abacoApp.add(new FerrariWidgetsModule());
abacoApp.add(new FerreroWidgetsModule());
abacoApp.add(new FibeoModule());
abacoApp.add(new GenericWidgetsModule());
abacoApp.add(new Geotagging());
abacoApp.add(new IrradiationWidgetModule());
abacoApp.add(new KnowledgeModule());
abacoApp.add(new IotModule());
abacoApp.add(new LayerManagementModule());
abacoApp.add(new LivestocksCountingModule());
abacoApp.add(new MapModule({ environment: MODE }));
abacoApp.add(new MelaviWidgetsModule());
abacoApp.add(new MessagesModule());
abacoApp.add(new MeteoWidgetModule());
abacoApp.add(menu);
abacoApp.add(new MowingWidgetModule());
abacoApp.add(new NavigationGisModule(MODE));
abacoApp.add(new NewAgreementsModule());
abacoApp.add(new NitratesDeclarationModule());
abacoApp.add(new ParcelTenureModule());
abacoApp.add(new PcertModule());
abacoApp.add(new PedologyModule());
abacoApp.add(new PoiModule());
abacoApp.add(new PortalGlobalStateModule());
abacoApp.add(new PrescriptionModule());
abacoApp.add(new PrincesWidgetsModule());
abacoApp.add(new ProcessesModule({ environment: MODE }));
abacoApp.add(new ProtocolModule());
abacoApp.add(new SupplyChainViewModule());
abacoApp.add(new SsoAdministrationModule());
abacoApp.add(new SatelliteIndexesModule());
abacoApp.add(new TimeSheetModule());
abacoApp.add(new ThermoWidgetModule());
abacoApp.add(new TrapsModule());
abacoApp.add(new TreatmentRegisterModule());
abacoApp.add(new UnifiWidgetsModule());
abacoApp.add(new UnaprolEmbeddedSectionsModule());
abacoApp.add(new UserModule());

if (isAbruzzo) {
    abacoApp.add(new PuaModule());
    abacoApp.add(new ExtractionModule());
}

if (isR2u) {
    abacoApp.add(new HelperModule());
    abacoApp.add(new R2UDashboardModule());
}

if (isPortal) {
    // Fake login
    abacoApp.add(new OuterLoginModule());
    abacoApp.add(new PizzoliWidgetModule());
}
if (isFerrero) {
    abacoApp.add(new FerreroChartsModule());
}
if (isMalta) {
    abacoApp.add(new FertilizerPlanModule());
    abacoApp.add(new MaltaS4fScpBridge());
    abacoApp.add(new PpmModule());
    abacoApp.add(new GabModule());
    abacoApp.add(new MaltaEmbeddedModule());
}

if (!isFerrero) {
    abacoApp.add(new BigDataGrapeWidgetModule());
    abacoApp.add(new BuyerContractModule());
    abacoApp.add(oldWidgets);
    abacoApp.add(new PrecisionFarmingModule());
}
if (!isMalta && !isFerrero) {
    abacoApp.add(new EarthwormWidgetModule());
    abacoApp.add(new PesslDiseasesWidgetModule());
    abacoApp.add(new ProviderServiceDionisoModule());
    abacoApp.add(new SouthernWatersWidgetModule());
}
if (isColdiretti) {
    abacoApp.add(new ColdirettiEmbeddedSectionsModule());
    abacoApp.add(new ColdirettiWidgetsModule());
    abacoApp.add(new DemetraAnalysisManagementModule());
    abacoApp.add(new PmiInspectionModule());
    abacoApp.add(new SmartAgriWidgetModule());
    abacoApp.add(new DamageClaimModule());
}

if (isColdirettiDemo) {
    abacoApp.add(new DemoColdirettiPopUpModule());
}

if (isA4grapes || isRemtec) {
    abacoApp.add(new GrapesDashboardModule());
}

if (isNiab) {
    abacoApp.add(new SoilHealthModule());
}
if (
    !isMalta &&
    !isFerrero &&
    !isColdiretti &&
    !isNiab &&
    !isAbruzzo &&
    !isR2u &&
    !isSian
) {
    abacoApp.add(new MosiModule());
}

if (isFerreroCounting) {
    abacoApp.add(new FerreroDashboardModule());
}
if (isFerreroOutGrower || isFerreroCounting) {
    abacoApp.add(new FerreroFixedDashboardModule());
}

type AppProviders = { envConfig: EnvConfig } | undefined;

abacoApp
    .start((h) => h(App))
    .then((vue) => vue.$mount("#app"))
    .then((vue) => {
        const providers =
            typeof vue.$options.provide === "function"
                ? (vue.$options.provide() as AppProviders)
                : (vue.$options.provide as AppProviders);
        if (
            providers != null &&
            providers.envConfig != null &&
            providers.envConfig.matomo != null
        ) {
            const matomoConfig = providers.envConfig.matomo as {
                domain: string;
                id: string;
            };
            startMatomo(matomoConfig.domain, matomoConfig.id);
        }
        return vue;
    })
    .catch((err) => {
        console.error(err);
        alert("An error has occurred");
    });
